/** A place from `/api/v2/location/name`, the same search the listing form uses. */
export interface PlaceHit {
  lid: number;
  name: string;
  active?: number;
  hierarchy?: { lid: number; name: string; level: number }[];
}

/** "Osu, Accra": the place plus its nearest parent area, when the search returned one. */
export function placeLabel(hit: PlaceHit): string {
  const parents = (hit.hierarchy ?? [])
    .filter((h) => h && typeof h === 'object' && h.lid !== hit.lid && h.name && h.name !== hit.name)
    .sort((a, b) => b.level - a.level);
  return parents[0] ? `${hit.name}, ${parents[0].name}` : hit.name;
}
